import React, { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';
import CloseIcon from '@mui/icons-material/Close';

import classnames from 'classnames';
import styles from './styles.module.sass';

type Props = {
  isOpen: boolean;
  onPopUpToggle?: () => void;
} & PropsWithChildren;

export const PopUp: React.FC<Props> = ({ children, isOpen, onPopUpToggle }) => {
  const handlerTogglePopUp = (e: React.MouseEvent<HTMLDivElement | SVGSVGElement, MouseEvent>) => {
    e.stopPropagation();
    onPopUpToggle();
  };

  return createPortal(
    <div onClick={handlerTogglePopUp} className={classnames(styles.pop_up, { [styles.active]: isOpen })}>
      <div onClick={(e) => e.stopPropagation()} className={styles.container}>
        <CloseIcon onClick={handlerTogglePopUp} className={styles.icon} />
        <div className={styles.content}>{children}</div>
      </div>
    </div>,
    document.getElementById('root'),
  );
};
